import { Typography } from "antd";

const { Title } = Typography;

export default function PricingPage() {
  return (
    <div className="pricing-page">
      <Title level={3} style={{ marginBottom: 8 }}>
        Pricing
      </Title>
    </div>
  );
}
